function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Link } from 'react-router-dom';
import cn from 'classnames';
import { motion } from 'framer-motion';
import { Button, Column, CustomModal, Row, TextButton, Typography, useOverlayContext } from 'seagull';
import { AnchorIcon, AnchorLogo, ArrowForward } from 'seagull/icons';
import { useResponsive } from "../../../../../client-flow/contexts";
import ExternalLinkButton from "../../../../ExternalLinkButton";
import { SecureLoginModal } from "../../../../SecureLoginModal/SecureLoginModal";
import { openInNewTabProps } from "../../../../../constants";
import { useEventReporter } from "../../../../../event-reporter";
import { useFeatureFlags } from "../../../../../hooks/useFeatureFlags";
import { Intent } from "../../../../../infra/access-control";
import { useStore, useStoreActions } from "../../../../../store/store-context";
import styles from "./CreateAVendorAccount.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const AnimatedArrowForward = () => /*#__PURE__*/_jsx(motion.div, {
  style: {
    width: 28,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  animate: {
    x: [-2, 2, -2]
  },
  transition: {
    duration: 1,
    ease: 'linear',
    repeat: Infinity
  },
  children: /*#__PURE__*/_jsx(ArrowForward, {})
});
export const CreateAVendorAccount = _ref => {
  let {
    variant,
    onClick,
    testId = 'create-a-vendor-account-btn'
  } = _ref;
  const userInfo = useStore(state => state.userInfo);
  const {
    setWorksAt
  } = useStoreActions();
  const {
    reportToHeap,
    reportToHubspot
  } = useEventReporter();
  const overlayContext = useOverlayContext();
  const {
    SET_IDENTITY_ONLY_TOKEN_FE
  } = useFeatureFlags();
  const {
    isDesktop
  } = useResponsive();
  const VariantContent = () => {
    switch (variant) {
      case 'animation':
        return /*#__PURE__*/_jsx(TextButton, {
          as: "div",
          intent: Intent.ClientCreateVendorAccount,
          className: cn(styles.banner, {
            [styles.mobile]: !isDesktop
          }),
          "data-testid": testId,
          onClick: onCreateVendorAccount,
          children: /*#__PURE__*/_jsxs(Row, {
            className: styles.bannerContent,
            children: [isDesktop && /*#__PURE__*/_jsx(AnchorIcon, {
              style: {
                height: 56,
                width: 56
              }
            }), /*#__PURE__*/_jsxs(Column, {
              children: [/*#__PURE__*/_jsx(Typography, {
                variant: "h6",
                weight: "normal",
                children: "Try Anchor for your business"
              }), /*#__PURE__*/_jsx(Typography, {
                variant: "paragraph1",
                children: "Send proposals, bill, and get paid. As simple as that."
              })]
            }), /*#__PURE__*/_jsxs(Button, {
              style: {
                minWidth: !isDesktop && 40
              },
              intent: Intent.ClientCreateVendorAccount,
              "data-testid": "".concat(testId, "-button"),
              children: [isDesktop ? 'Get started free' : '', " ", /*#__PURE__*/_jsx(AnimatedArrowForward, {})]
            })]
          })
        });
      case 'button':
        return /*#__PURE__*/_jsx("div", {
          "data-testid": "create-a-vendor-account",
          children: /*#__PURE__*/_jsx(Button, {
            onClick: onCreateVendorAccount,
            "data-testid": testId,
            intent: Intent.ClientCreateVendorAccount,
            children: "Create a Service Provider Account"
          })
        });
      case 'text':
        return /*#__PURE__*/_jsxs("div", {
          "data-testid": "create-a-vendor-account",
          children: [/*#__PURE__*/_jsx(TextButton, {
            className: styles.createVendorPromptText,
            underline: "none",
            onClick: onCreateVendorAccount,
            "data-testid": testId,
            intent: Intent.ClientCreateVendorAccount,
            children: "Sign up for a service provider account"
          }), /*#__PURE__*/_jsxs(Typography, {
            as: "span",
            className: styles.createVendorPromptText,
            children: [' ', "- it's free"]
          })]
        });
    }
  };
  const onCreateVendorAccount = async () => {
    onClick === null || onClick === void 0 || onClick();
    reportToHubspot('create_vendor_account_clicked_v2');
    reportToHeap('top-bar', 'click', 'client-create-vendor-account-topbar');
    let hasIdentity = !!(userInfo !== null && userInfo !== void 0 && userInfo.hasIdentity());
    if (!hasIdentity && !SET_IDENTITY_ONLY_TOKEN_FE) {
      hasIdentity = await overlayContext.showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: _ref2 => {
          let {
            dismissModal
          } = _ref2;
          return /*#__PURE__*/_jsx(SecureLoginModal, {
            dismissModal: dismissModal
          });
        }
      });
    }
    if (hasIdentity || SET_IDENTITY_ONLY_TOKEN_FE) {
      const shouldCreateAVendorAccount = await overlayContext.showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: _ref3 => {
          let {
            dismissModal
          } = _ref3;
          return /*#__PURE__*/_jsx(CreateVendorAccountConfirmationModalWithFF, {
            dismissModal: dismissModal
          });
        }
      });
      if (shouldCreateAVendorAccount) {
        await setWorksAt();
      }
    } else {
      reportToHubspot('create_vendor_account_canceled_v3');
    }
  };
  return /*#__PURE__*/_jsx(VariantContent, {});
};
const CreateVendorAccountConfirmationModalWithFF = _ref4 => {
  let {
    dismissModal
  } = _ref4;
  const userInfo = useStore(state => state.userInfo);
  const {
    api,
    logBI
  } = useStoreActions();
  const {
    reportToHeap,
    reportToHubspot
  } = useEventReporter();
  const {
    isDesktop
  } = useResponsive();
  return /*#__PURE__*/_jsx(CustomModal, {
    maxWidth: isDesktop ? 600 : '100%',
    maxHeight: isDesktop ? '90vh' : '100%',
    title: "Create Service Provider account",
    onClose: () => {
      dismissModal(false);
      reportToHubspot('create_vendor_account_canceled_v3');
    },
    "data-testid": "create-vendor-account-confirmation",
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      style: {
        padding: isDesktop ? 0 : '8px'
      },
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.bodyContainer,
        children: [/*#__PURE__*/_jsx(AnchorLogo, {
          width: 180,
          height: 50,
          className: styles.logo
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "h3",
          className: styles.title,
          children: "Create a Service Provider account"
        }), /*#__PURE__*/_jsx(Typography, {
          className: styles.message,
          variant: "h6",
          skin: "disabled",
          children: "Anchor allows service providers to fully automate their billing, in a simple, flexible, and affordable way. Send proposals, get them signed, invoiced, paid, and fully synced to your favorite accounting software - all automatically!"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.footer,
        style: _objectSpread({}, !isDesktop && {
          padding: '8px'
        }),
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs(Typography, {
            as: "span",
            variant: "paragraph2",
            skin: "disabled",
            weight: "light",
            children: ["By creating a Seller account, you agree to our", ' ']
          }), /*#__PURE__*/_jsx(TextButton, _objectSpread(_objectSpread({
            as: Link,
            size: "small",
            skin: "secondary",
            to: {
              pathname: 'https://www.sayanchor.com/terms-of-contact'
            }
          }, openInNewTabProps), {}, {
            underline: "none",
            children: "Terms of Service"
          })), /*#__PURE__*/_jsxs(Typography, {
            as: "span",
            variant: "paragraph2",
            skin: "disabled",
            weight: "light",
            children: [' ', "and", ' ']
          }), /*#__PURE__*/_jsx(TextButton, _objectSpread(_objectSpread({
            as: Link,
            size: "small",
            skin: "secondary",
            to: {
              pathname: 'https://www.sayanchor.com/privacy-policy'
            }
          }, openInNewTabProps), {}, {
            underline: "none",
            children: "Privacy policy"
          })), /*#__PURE__*/_jsx(Typography, {
            as: "span",
            variant: "paragraph2",
            skin: "disabled",
            weight: "light",
            children: "."
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.actions,
          style: _objectSpread({}, !isDesktop && {
            alignItems: 'center'
          }),
          children: [/*#__PURE__*/_jsx(ExternalLinkButton, {
            style: _objectSpread({}, !isDesktop && {
              height: '100%'
            }),
            testid: 'client-create-vendor-book-a-demo',
            openInNewTab: true,
            size: "medium",
            underline: "none",
            className: styles.demoButton,
            href: "https://meetings.hubspot.com/tal57/book-a-demo-website?utm_source=in-app&utm_medium=client_to_vendor&utm_campaign=get_a_demo_button",
            children: "Book a demo"
          }), /*#__PURE__*/_jsx(Button, {
            size: "medium",
            style: _objectSpread({}, !isDesktop && {
              height: '100%'
            }),
            onClick: async () => {
              logBI(18101);
              reportToHubspot('create_vendor_account_approve_v4');
              reportToHeap('top-bar', 'click', 'client-create-vendor-account-approve');
              if (!(userInfo !== null && userInfo !== void 0 && userInfo.hasApprovedTermsOfService())) {
                const userId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id();
                if (userId) {
                  await api.auth.approveTos(userId);
                }
              }
              await dismissModal(true);
            },
            "data-testid": "create-vendor-account-approve-btn",
            children: "Create Service Provider account"
          })]
        })]
      })]
    })
  });
};